import { useCountMetaRentReportingController } from "./count-meta-controller";
import { useRentReportingController } from "./rent-reporting-controller";

export const useCombinedRentReportingController = () => {
  const rentReporting = useRentReportingController();
  const rentReportingMeta = useCountMetaRentReportingController();

  return {
    ...rentReporting,
    ...rentReportingMeta
  };
};
